var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBrigoshaLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "brigoshaLogo",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17234",
    "data-name": "Rectangle 17234",
    width: 24,
    height: 23,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Brigosha_logo",
    "data-name": "Brigosha logo",
    transform: "translate(2.749 0.329)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M16.942,2.274A2.3,2.3,0,0,0,14.627,0H2.315A2.3,2.3,0,0,0,0,2.274V20.359a2.3,2.3,0,0,0,2.315,2.274H14.627a2.3,2.3,0,0,0,2.315-2.274Zm-1.373.347A1.36,1.36,0,0,0,14.2,1.272H2.747A1.36,1.36,0,0,0,1.375,2.62V19.933a1.359,1.359,0,0,0,1.372,1.349H14.2a1.359,1.359,0,0,0,1.372-1.349Z",
    transform: "translate(0 0)",
    fill: "#0086ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M21.433,30.436c.008.789-.475.9-1.058.914-2.6.047-4.849-1.77-4.63-6.994.012-.292.027-.584.066-.874q.039-.289.1-.574A8.908,8.908,0,0,1,17.28,19.8a10.053,10.053,0,0,1,.764-.986q.141-.16.288-.312c.077-.08.156-.159.239-.235l.008-.007c.017-.013.033-.027.05-.04a.855.855,0,0,1,1.119.094.83.83,0,0,1,.173.266.815.815,0,0,1,.035.5.83.83,0,0,1-.264.428l0,0,0,0h0l-.005,0-.017.016-.042.04c-.161.159-.312.329-.456.5q-.263.316-.494.657-.124.183-.238.371a7.1,7.1,0,0,0-.871,2.112q-.039.173-.067.347-.042.255-.061.514a5.586,5.586,0,0,0,.094,1.5H20.1a1.358,1.358,0,0,1,1.37,1.345Z",
    transform: "translate(-12.777 -14.661)",
    fill: "#0086ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M48.375,37.335c-.008-.789.475-.9,1.058-.914,2.6-.047,4.849,1.77,4.63,6.994-.012.292-.027.584-.066.874q-.039.289-.1.574a8.908,8.908,0,0,1-1.368,3.112,10.065,10.065,0,0,1-.764.986q-.141.16-.288.312c-.077.08-.156.159-.239.235l-.008.007-.05.04a.875.875,0,0,1-.109.068.858.858,0,0,1-.689.047.848.848,0,0,1-.322-.207.829.829,0,0,1-.173-.266.815.815,0,0,1-.035-.5.826.826,0,0,1,.173-.337.84.84,0,0,1,.09-.091l0,0,0,0h0l.005,0,.017-.016.042-.04c.161-.159.312-.329.456-.5q.263-.316.494-.657.124-.183.238-.371a7.1,7.1,0,0,0,.871-2.112q.039-.173.067-.347.042-.255.061-.514a5.586,5.586,0,0,0-.094-1.5H49.71a1.358,1.358,0,0,1-1.37-1.345Z",
    transform: "translate(-39.264 -30.582)",
    fill: "#0086ff",
    fillRule: "evenodd"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrigoshaLogo);
export default __webpack_public_path__ + "static/media/brigoshaLogo.402b7e7274865e71972252832a4b005c.svg";
export { ForwardRef as ReactComponent };